import { render, staticRenderFns } from "./CreateMoNoiseBlock.vue?vue&type=template&id=39f229da&scoped=true"
import script from "./CreateMoNoiseBlock.vue?vue&type=script&lang=js"
export * from "./CreateMoNoiseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f229da",
  null
  
)

export default component.exports